<template>
  <div class="error" v-if="page.errorserver">
    <div class="error__inner">
      <div class="error__title" v-html="page.errorserver.text_error_status"></div>
      <div class="error__text" v-html="page.errorserver.text_error_title"></div>
      <div v-html="page.errorserver.text_error_text"></div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'errorServer',
    data() {
      return {
        title: '',
      };
    },
    metaInfo() {
      return {
        title: this.title,
      };
    },
    watch: {
      page() {
        this.title = this.page.errorserver.title;
      },
    },
    computed: mapGetters({
      lang: 'lang',
      page: 'page',
    }),
    mounted() {
      this.$store.dispatch('fetchPage', { lang: this.lang, $http: this.$http });
      this.$store.commit('SET_ERROR_PAGE_STATE', true);
    },
  };
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/ErrorServer.vue?1b220054